import { t } from 'Src/i18n';
import { isSeller } from 'Utils/seller/sellerUtils';
import { formatApiDate } from 'Utils/date/apiDate';
import { upperCaseLetterToInt } from 'Components/utils/string/string.util';
import type { ServicesContextType } from 'Context/ServicesContext';
import 'Context/ServicesContext';
import { capitalizeWordFirstCaracter } from 'Utils/string/stringUtils';
export const MORNING = 'MORNING';
export const AFTERNOON_BEFORE_5PM = 'AFTERNOON_BEFORE_5PM';
export const AFTERNOON_AFTER_5PM = 'AFTERNOON_AFTER_5PM';
export const AFTERNOON_BEFORE_4PM = 'AFTERNOON_BEFORE_4PM';
export const AFTERNOON_AFTER_4PM = 'AFTERNOON_AFTER_4PM';
// childcares
export const AFTERNOON = 'AFTERNOON';
export const RENTAL = 'RENTAL';
export const getSlotKey = ({
  slotName,
  startDate,
  endDate,
  attendeeId,
}: {
  slotName: string;
  startDate: string;
  endDate: string;
  attendeeId: string;
}) => `${slotName}-${startDate}-${endDate}-${attendeeId}`;
export const getAttendeeLabel = (
  attendeesList: ServicesContextType['attendeesList'],
  attendeeId: string,
  appContext: AppContext,
) => {
  const { unicodeFirstName, firstName, unicodeLastName, lastName, birthdate, isChild } =
    attendeesList.find(({ id }) => id === attendeeId) || {};
  const attendeeFirstName =
    unicodeFirstName?.trim() || capitalizeWordFirstCaracter(firstName?.trim() || '');
  const attendeeLastName =
    unicodeLastName?.trim() || capitalizeWordFirstCaracter(lastName?.trim() || '');
  let attendeelabel = `${String(attendeeFirstName)}${attendeeFirstName ? ' ' : ''}${String(attendeeLastName)}`;

  if (attendeelabel && isSeller(appContext) && isChild && birthdate) {
    attendeelabel += ` (${formatApiDate(birthdate, t('common.dateFormatTechnicalID'))})`;
  }

  return isChild && birthdate && !attendeelabel
    ? t('booking.services.childcare.forWhatKid', {
        birthdate: formatApiDate(birthdate, t('common.dateFormatTechnicalID')),
      })
    : attendeelabel ||
        `${t(!isChild ? 'booking.common.adult' : 'booking.common.child')} ${upperCaseLetterToInt(attendeeId)}`;
};
export const activityOrEquipementDetailClick = (
  isCancellingActivity: boolean,
  isRental: boolean,
) => {
  if (isRental) {
    return isCancellingActivity ? 'remove_ski_equipment' : 'add_ski_equipment';
  }

  return isCancellingActivity ? 'remove_activity' : 'add_activity';
};
